import React from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { getRole } from '../../../global/blocs/roomInfo'
import SecondCamLayout from '../WebinarContainerComponent/helpers/SecondCamLayout'

const getIsGearMode = (state?: any) => state?.webinar?.isGearMode

const SecondCamContainer = () => {
  const isInGearMode = useSelector(getIsGearMode)
  const role = getRole()

  const className = classnames(`webinar-container-component role-${role}`, {
    'is-gear-mode': isInGearMode,
  })

  return (
    <div className={`${className} second-cam`}>
      <SecondCamLayout />
    </div>
  )
}

export { SecondCamContainer }
